/* eslint-disable */
import { produce } from "immer";
import {
  ADDRESS_FETCH_FAILURE,
  ADDRESS_FETCH_SUCCESS,
  ADDRESS_FETCH_START,
} from "../actions/types";

const address = (
  state = {
    addressFetching: false,
    addressData: [],
    addressError: null,
  },
  action,
) => {
  switch (action.type) {
    case ADDRESS_FETCH_START:
      return produce(state, (draft) => {
        draft.addressFetching = true;
      });
    case ADDRESS_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.addressFetching = true;
        draft.addressData = action.data;
        draft.addressFetching = false;
      });
    case ADDRESS_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.addressFetching = false;
        draft.addressError = action.error;
      });
    default:
      return state;
  }
};

export default address;
